import { types } from "mobx-state-tree";
import fetcher from "../utils/fetcher";

const UserStore = types
  .model("customersConnectionsStore", {
    error: types.frozen(),
    customerConnections: types.frozen(),
  })
  .actions((self) => {
    async function getCustomerConnections(data) {
      self.setError("");
      const response = await fetcher()
        .post(data)
        .from.customers_connections.get_customer_connections(data);
      if (response.status === 200 && response.data) {
        self.setCustomerConnections(response.data);
        return response.data;
      } else {
        self.setError(
          response?.status === 400 || response?.status === 500
            ? response?.data?.FORM?.InterfaceErrors?.text ||
                "error:error_failed_get_customer_connection"
            : "error:error_failed_get_customer_connection"
        );
      }
    }

    async function updateCustomerConnection(data) {
      self.setError("");
      const response = await fetcher()
        .post(data)
        .from.customers_connections.update_customer_connection(data);
      if (response.status === 200 && response.data) {
        return response.data;
      } else {
        self.setError(
          response?.status === 400 || response?.status === 500
            ? response?.data?.FORM?.InterfaceErrors?.text ||
                "error:error_failed_update_customer_connection"
            : "error:error_failed_update_customer_connection"
        );
      }
    }
    async function addCustomerConnection(data) {
      self.setError("");
      const response = await fetcher()
        .post(data)
        .from.customers_connections.add_customer_connection(data);
      if (response.status === 200 && response.data) {
        return response.data;
      } else {
        self.setError(
          response?.status === 400 || response?.status === 500
            ? response?.data?.FORM?.InterfaceErrors?.text ||
                "error:error_failed_add_customer_connection"
            : "error:error_failed_add_customer_connection"
        );
      }
    }

    async function deleteCustomerConnection(data) {
      self.setError("");
      const response = await fetcher()
        .post(data)
        .from.customers_connections.delete_customer_connection(data);
      if (response.status === 200 && response.data) {
        return response.data;
      } else {
        self.setError(
          response?.status === 400 || response?.status === 500
            ? response?.data?.FORM?.InterfaceErrors?.text ||
                "error:error_failed_delete_customer_connection"
            : "error:error_failed_update_customer_connection"
        );
      }
    }

    async function getConnectionTypes() {
      self.setError("");
      const response = await fetcher()
        .post()
        .from.customers_connections.get_connection_types();
      if (response.status === 200 && response.data) {
        return response.data;
      } else {
        self.setError(
          response?.status === 400 || response?.status === 500
            ? response?.data?.FORM?.InterfaceErrors?.text ||
                "error:error_failed_get_connection_type"
            : "error:error_failed_get_connection_type"
        );
      }
    }

    function setError(error) {
      self.error = error;
    }

    function setCustomerConnections(connections) {
      self.customerConnections = connections;
    }

    return {
      getCustomerConnections,
      setCustomerConnections,
      addCustomerConnection,
      updateCustomerConnection,
      deleteCustomerConnection,
      setError,
      getConnectionTypes,
    };
  })
  .views((self) => ({
    get isError() {
      return !!self.error;
    },
  }));

const customersConnectionsStore = UserStore.create({
  error: "",
  customersConnections: [],
});
export default customersConnectionsStore;
